<template>
  <div>
    <div class="has-friends">
      <c-switcher v-model="hasFriends" label="Есть знакомые, работающие в компании" />
    </div>
    <transition name="slide">
      <div v-if="hasFriends" class="who">
        <c-textarea v-model="friends" floating-label="Укажите, кто именно" :clearable="true" />
      </div>
    </transition>
  </div>
</template>

<script>
import CSwitcher from "@/components/controls/switcher";
import CTextarea from "@/components/controls/textarea";

export default {
  components: { CSwitcher, CTextarea },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      hasFriends: false,
      friends: "",
    };
  },

  watch: {
    hasFriends(v) {
      if (!v) {
        this.friends = "";
      }
      this.updateValue();
    },
    friends() {
      this.updateValue();
    },
    value(v) {
      this.setData(v);
    },
  },

  created() {
    if (this.value) this.setData(this.value);
  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;
      const { hasFriends, friends } = value.value || {};
      this.hasFriends = hasFriends === "0" ? false : !!hasFriends;
      this.friends = friends || "";
      this.$nextTick(() => {
        this.inited = true;
      });
    },
    updateValue() {
      this.$emit("input", {
        value: {
          hasFriends: this.hasFriends ? 1 : 0,
          friends: this.friends,
        },
      });
      if (this.inited) this.$emit("change");
    },
  },
};
</script>

<style lang="scss" scoped>
.who {
  margin-top: 25px;
}
</style>
